import React from 'react';
import {InputText} from '../../blocks/inputs/InputText';
import Checkbox from 'material-ui/Checkbox';
import PasswordWrapper from 'modules/blocks/inputs/PasswordWrapper';
import _ from 'lodash';
import HttpClient from 'services/HttpClient';
import validate from 'validate.js';
import {USER_CONSTRAINS} from 'constants/usersConstrains';
import {inject} from 'mobx-react';
import {Link, withRouter} from 'react-router-dom';
import createAcc from 'images/createAcc.png';
import checkedIcon from 'images/checked.svg';

const CREATE_USER = '/api/v1/users';

@withRouter
@inject('userStore')
@inject('alertStore')
export default class SignUpForm extends React.Component {

  state = {
    errors  : {},
    formData: {
      first_name        : '',
      last_name         : '',
      email             : '',
      password          : '',
      password_confirmation: ''
    },
    agree: false
  };

  updateCheck = () => {
    this.setState({
      ...this.state,
      agree: !this.state.agree
    })
  }

  submit = e => {
    e.preventDefault();
    if (!this.state.agree) return null;
    let newFormDate = _.assign({}, this.state.formData);
    let errors = validate(newFormDate, USER_CONSTRAINS, {fullMessages: false});

    if (errors) {
      this.setState({errors: errors});
    } else {
      this.setState({errors: {}});
      new HttpClient().post(CREATE_USER, {user: this.state.formData}).then(data => {
        const token = data.body.token;
        const user = data.body.user;
        this.props.userStore.loginUser(user, token);
        this.props.alertStore.success('You successfully signed up');
        this.props.history.push('/')
      }).catch(() => {
        this.setState({errors: {email: 'Email has already been taken'}})
      });
    }

  };

  handleChange = e => {
    if (e.target.name === 'user_type') {
      this.changeAdditionalForms(e);
    } else {
      let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
      this.setState({formData: newState});
    }
  };

  render() {
    return (
      <div className="new-form-wrapper">
        <img src={createAcc} />
        <form className="sign-in-form" onSubmit={this.submit}>
          <h2>Create Your Account</h2>
          <div className="name-info-block">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="input-wrap">
                  <InputText
                    onChange={this.handleChange}
                    className='name'
                    name="first_name"
                    value={this.state.formData.first_name}
                    label="First Name"
                    placeholder='Enter First Name'
                    type="text"
                    errorText={this.state.errors.first_name}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="input-wrap">
                  <InputText
                    className='surname'
                    name="last_name"
                    value={this.state.formData.last_name}
                    errorText={this.state.errors.last_name}
                    onChange={this.handleChange}
                    label="Surname"
                    placeholder='Enter Surname'
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="input-wrap">
            <InputText
              name="email"
              value={this.state.formData.email}
              onChange={this.handleChange}
              className='email'
              errorText={this.state.errors.email}
              label="Email"
              placeholder='Enter Email'
              type="email"
            />
          </div>
          <PasswordWrapper value={this.state.formData.password}
            errorText={this.state.errors.password}
            name="password"
            label="Password"
            placeholder='Enter Password'
            handleChange={this.handleChange}
          />
          { !this.state.errors.password &&
            <span className="input-label">Must be at least 6 characters and contain at least one number and one capital letter</span>
          }
          <PasswordWrapper value={this.state.formData.password_confirmation}
            errorText={this.state.errors.password_confirmation}
            name="password_confirmation"
            label="Password Confirmation"
            placeholder='Confirm Password'
            handleChange={this.handleChange}
          />
          <div className='agree-wrap'>
            <Checkbox
              label=''
              checked={this.state.agree}
              onCheck={this.updateCheck}
              color='#467093'
              checkedIcon={<img src={checkedIcon} />}
              style={{width: '28'}}
            />
            <span>I have read and understand the <a href="/privacy-policy">Privacy Policy</a></span>
          </div>
          <div className="button-set">
            <button className="btn-new-main" style={{width: '100%'}} type="submit" disabled={!this.state.agree}>Sign Up</button>
            <div className="help-label">
              <span>Already have an account? </span><Link to="/signIn">Log In</Link>
            </div>
          </div>
        </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/SignUpForm.js